module.exports = __webpack_public_path__ + "static/C55C03E5-0F18-41F4-BB88-C152BA99BC4B-0d621fab3f7994102532e700a32c108e.jpg";